'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = require('assert');
var _ = require('lodash');
var uuid = require('uuid');

var Pubsub = function () {
  function Pubsub() {
    _classCallCheck(this, Pubsub);

    this.subscribers = {};
    this.publish = this.publish.bind(this); // Necessary for ConnectPubsub
  }

  _createClass(Pubsub, [{
    key: 'publish',
    value: function publish(eventName, data) {
      var subscribers = this.subscribers;

      // Get all the subscribers

      var eventSubscribers = _.flatten([_.values(subscribers['*']), _.values(subscribers[eventName]), _.values(subscribers[eventName + ':*'])]);

      // Go through each subscriber and trigger the function, catch and log errors
      _.forEach(eventSubscribers, function (subscriberFn) {
        subscriberFn(eventName, data);
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(eventName, fn) {
      var subscribers = this.subscribers;

      // Ensure the function is valid

      assert(_.isFunction(fn), 'Subscribe function is not a function: ' + fn + ' (event: \'' + eventName + '\')');

      // Create or reuse existing subscribers object
      subscribers[eventName] = subscribers[eventName] || {};
      // Create an ID that can be used to unsubscribe
      var subscribeId = uuid.v4();
      // Assign function to that
      subscribers[eventName][subscribeId] = fn;
      // Return ID so it can be used to unsubscribe
      return subscribeId;
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(eventName, subscribeId) {
      var subscribers = this.subscribers;


      if (subscribers[eventName] && subscribers[eventName][subscribeId]) {
        delete subscribers[eventName][subscribeId];
      }
    }
  }]);

  return Pubsub;
}();

module.exports = Pubsub;